var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-sale-box-wrapper h-spc51 md:h-spc51 sm:h-spc74 overflow-hidden bg-primaryColor fixed bottom-0 left-0 w-full",attrs:{"id":"footer-sale-box"}})}
var staticRenderFns = []

export { render, staticRenderFns }